import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SubdomainFragment as Subdomain,
    GetSubdomains as GetSubdomainsQuery,
} from 'nutshell-graphql-types';

import GET_SUBDOMAINS from '../queries/get-subdomains.graphql';

export function useGetSubdomains(includeNutshellManaged?: boolean): {
    subdomains: Subdomain[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, error, loading, refetch} = useQuery<GetSubdomainsQuery, Record<any, any>>(
        GET_SUBDOMAINS,
        {
            fetchPolicy: 'cache-and-network',
            variables: {
                includeNutshellManaged,
            },
        }
    );

    return {
        subdomains: data ? data.subdomains : [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
